import type { TsCodeType, VariableNameType } from '../../types.js'
import { Block } from '../block.js'
import {
	jsonClass,
	jsonProperty,
	jsonMapProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { BoReference } from '../../bos/bo-reference.js'
import { BlockComponentImport } from '../block-component-import.js'

@jsonClass('ScreenBlock')
export class ScreenBlock extends Block {
	@jsonProperty(BoReference)
	@ScreenEditorInput({
		inputType: 'boRef',
		order: 1,
		label: 'Screen',
		allowedBoTypes: ['Screen'],
		includeImportedModules: true,
		isMandatory: () => true,
	})
	screenRef: BoReference<'Screen'> = new BoReference()
	@jsonMapProperty(String, String) assignments?: Map<
		VariableNameType,
		TsCodeType
	> = new Map()

	constructor(init: Partial<ScreenBlock> = {}) {
		super()
		this.init(init)
	}

	getEditorTitle() {
		return `${super.getEditorTitle()} ${this.screenRef?.getQualifiedName()}`
	}

	getTitleBackgroundAndBorderColor(): string {
		return '#81c784'
	}

	getTitleColor(): string {
		return '#1b3d1e'
	}

	getEditableBo(): BoReference {
		return this.screenRef
	}

	shouldRenderContentAreaWrappers() {
		return true
	}

	getEditorCategory(): string {
		return 'Screen Structure'
	}

	needsBoSpecificDetailsForRefs(): BoReference[] {
		return [this.screenRef]
	}
}
